import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { adminApi } from "@/lib/adminAuth";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";

const SLOTS = ["home_top", "home_middle", "result_bottom", "dashboard_side"];
const empty = { slot: "home_top", title: "", image_url: "", target_url: "", is_active: true, sort_order: 10 };

export default function AdminBanners() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [creating, setCreating] = useState(false);

  const load = () => api.get("/admin/ad-banners", adminApi()).then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      if (creating) await api.post("/admin/ad-banners", editing, adminApi());
      else await api.patch(`/admin/ad-banners/${editing.id}`, editing, adminApi());
      toast.success("Kaydedildi");
      setEditing(null); setCreating(false);
      load();
    } catch { toast.error("Hata"); }
  };

  const remove = async (id) => {
    if (!window.confirm("Silinsin mi?")) return;
    await api.delete(`/admin/ad-banners/${id}`, adminApi());
    load();
  };

  return (
    <div className="font-admin-body">
      <div className="flex items-center justify-between mb-6">
        <h1 className="font-admin-head text-3xl">Reklam Banner'ları</h1>
        <button onClick={() => { setCreating(true); setEditing({ ...empty }); }} className="admin-btn flex items-center gap-2"><Plus className="w-4 h-4" /> Yeni Banner</button>
      </div>
      <p className="text-sm text-white/60 mb-4">AdMob'a ek olarak kendi banner'larını yükle. Ayarlar sayfasında AdMob ID'lerini gir.</p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {items.map((b) => (
          <div key={b.id} className="admin-card overflow-hidden">
            <div className="aspect-video bg-white/5 bg-cover bg-center" style={{ backgroundImage: b.image_url ? `url(${b.image_url})` : undefined }} />
            <div className="p-3">
              <div className="text-xs text-white/50">{b.slot}</div>
              <div className="font-admin-head text-sm truncate">{b.title}</div>
              <div className="text-xs text-white/40 truncate">{b.target_url}</div>
              <div className="flex gap-2 mt-2">
                <button onClick={() => setEditing({ ...b })} className="admin-btn-ghost text-xs px-2 py-1 flex-1">Düzenle</button>
                <button onClick={() => remove(b.id)} className="admin-btn-ghost text-xs px-2 py-1 text-red-400"><Trash2 className="w-3 h-3" /></button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {editing && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/85 p-4">
          <div className="admin-card p-6 w-full max-w-md">
            <h2 className="font-admin-head text-xl mb-4">{creating ? "Yeni Banner" : "Banner Düzenle"}</h2>
            <div className="space-y-3">
              <div><label className="text-xs text-white/50">Slot</label><select value={editing.slot} onChange={(e) => setEditing({ ...editing, slot: e.target.value })} className="admin-input">{SLOTS.map(s => <option key={s} value={s}>{s}</option>)}</select></div>
              <div><label className="text-xs text-white/50">Başlık</label><input value={editing.title} onChange={(e) => setEditing({ ...editing, title: e.target.value })} className="admin-input" /></div>
              <div><label className="text-xs text-white/50">Görsel URL</label><input value={editing.image_url} onChange={(e) => setEditing({ ...editing, image_url: e.target.value })} className="admin-input" /></div>
              <div><label className="text-xs text-white/50">Hedef URL</label><input value={editing.target_url} onChange={(e) => setEditing({ ...editing, target_url: e.target.value })} className="admin-input" /></div>
              <div><label className="text-xs text-white/50">Sıra</label><input type="number" value={editing.sort_order} onChange={(e) => setEditing({ ...editing, sort_order: parseInt(e.target.value) || 0 })} className="admin-input" /></div>
              <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={!!editing.is_active} onChange={(e) => setEditing({ ...editing, is_active: e.target.checked })} className="accent-[#F59E0B]" /> Aktif</label>
            </div>
            <div className="flex gap-2 mt-6">
              <button onClick={save} className="admin-btn flex-1">Kaydet</button>
              <button onClick={() => { setEditing(null); setCreating(false); }} className="admin-btn-ghost flex-1">İptal</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
